import { utcToJSDate } from "@/utils/date-time";
import { PaginationFilterRequest } from "./core.model";
import { City } from "./city.model";
import { RunEventKey } from "./run-event-key.model";
import { RunEventDistanceTypeEnum } from "./run-event-distance.model";
import { EventLink } from "./event-link.model";

export function runEventFromJson<T extends RunEvent|RunEventList>(json: any): T {
  return {
    ...json,
    registrationDate: utcToJSDate(json.registrationDate)
  } as T;
};

export interface RunEvent {
    id: number;
    name: string;
    description: string;
    cityId: number;
    city: City;
    imageUrl?: string;
    website?: string;
    links?: EventLink[];
    registrationDate?: Date;
    runEventKey?: RunEventKey;
    type: RunEventType;
    status: RunEventStatus;
    isMajor: boolean;
}
export interface RunEventList {
    id: number;
    name: string;
    cityId: number;
    city: City;
    imageUrl?: string;
    website?: string;
    registrationDate?: Date;
    distances: RunEventListDistanceInfo[];
    runEventKey?: RunEventKey;
    type: RunEventType;
    status: RunEventStatus;
    isMajor: boolean;
}
export interface RunEventListDistanceInfo {
    distance: number;
    type: RunEventDistanceTypeEnum;
}

export interface UpsertRunEvent {
    id?: number;
    name?: string;
    description?: string;
    cityId?: number;
    runEventKeyId?: number;
    imageUrl?: string;
    website?: string;
    links?: EventLink[];
    registrationDate?: Date;
    type?: RunEventType;
    status?: RunEventStatus;
    isMajor?: boolean;
}

export class RunEventPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
    runEventKeyId?: number;
    type?: RunEventType;
    status?: RunEventStatus;
    onlyMajors?: boolean = false;
    onlyStartedDistances?: boolean = false;
}

export enum RunEventType
{
    RunEvent = 1,
    Marathon = 2,
    Trail = 3,
    Hyrox = 4,
}
export const RunEventTypeList = [
    {value: 1, label: "Run Event"},
    {value: 2, label: "Marathon"},
    {value: 3, label: "Trail"},
    {value: 4, label: "Hyrox"},
];

export enum RunEventStatus
{
    Draft = 0,
    Coming = 1,
    RegistrationOpen = 2,
    WaitingToStart = 3,
    Started = 4,
    Finished = 5,
    Canceled = 6
}
export const RunEventStatusList = [
    {value: 0, label: "Draft"},
    {value: 1, label: "Coming"},
    {value: 2, label: "Registration Open"},
    {value: 3, label: "Waiting to Start"},
    {value: 4, label: "Started"},
    {value: 5, label: "Finished"},
    {value: 6, label: "Canceled"}
];